(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  if (!customElements.get('ma-locker-delivery')) {
    customElements.define('ma-locker-delivery', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.keys = ['MA_delivery_preference', 'MA_locker_ready', 'Pickup carrier', 'Pickup point ID', 'Pickup point name', 'Pickup point country', 'Pickup original point ID'];
        this.carriers = { inpost: 'InPost', dpd: 'DPD', orlen: 'ORLEN' };
        this.preference = 'home';
        this.point = null;
        this.saved = false;
        this.pending = 0;
        this.revision = 0;
        this.mapEpoch = 0;
        this.refreshEpoch = 0;
        this.itemCount = Number(this.dataset.itemCount) || 0;
        this.queue = Promise.resolve();
        this.radios = [...this.querySelectorAll('input[type="radio"]')];
        this.chooseButton = this.querySelector('[data-choose-locker]');
        this.status = this.querySelector('[data-delivery-status]');
        this.error = this.querySelector('[data-delivery-error]');
        this.form = document.getElementById('cart');
        this.dialog = this.querySelector('[data-map-dialog]');
        this.mapContainer = this.querySelector('[data-map-container]');
        this.closeMapButton = this.querySelector('[data-close-map]');
        this.onCloseMap = () => this.cancelMap();
        this.onDialogCancel = (event) => { event.preventDefault(); this.cancelMap(); };
        this.closeMapButton.addEventListener('click', this.onCloseMap);
        this.dialog.addEventListener('cancel', this.onDialogCancel);
        this.onChange = (event) => {
          if (!this.radios.includes(event.target)) return;
          this.preference = event.target.value;
          this.notice = '';
          this.point = null;
          this.mapEpoch += 1;
          this.mapOpen = false;
          this.revision += 1;
          this.saved = false;
          this.error.textContent = '';
          this.commit(this.attributes(), this.revision);
        };
        this.onChoose = () => this.openMap();
        this.onPageShow = () => this.refresh();
        this.onSubmit = (event) => this.checkout(event);
        this.addEventListener('change', this.onChange);
        this.chooseButton.addEventListener('click', this.onChoose);
        this.onRetry = () => this.commit(this.attributes(), this.revision);
        this.querySelector('[data-save-retry]').addEventListener('click', this.onRetry);
        window.addEventListener('pageshow', this.onPageShow);
        this.form?.addEventListener('submit', this.onSubmit, true);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        }
        this.render();
        this.refresh();
      }

      disconnectedCallback() {
        this.mapEpoch += 1;
        this.refreshEpoch += 1;
        this.removeEventListener('change', this.onChange);
        this.chooseButton?.removeEventListener('click', this.onChoose);
        this.querySelector('[data-save-retry]')?.removeEventListener('click', this.onRetry);
        window.removeEventListener('pageshow', this.onPageShow);
        this.form?.removeEventListener('submit', this.onSubmit, true);
        this.unsubscribe?.();
        this.closeMapButton?.removeEventListener('click', this.onCloseMap);
        this.dialog?.removeEventListener('cancel', this.onDialogCancel);
        this.dismissMap();
        this.initialized = false;
      }

      clean(value, max) {
        if (typeof value !== 'string' && typeof value !== 'number') return '';
        if (typeof value === 'number' && !Number.isFinite(value)) return '';
        const text = String(value).trim();
        return text.length <= max && !/[\u0000-\u001f\u007f]/.test(text) ? text : '';
      }

      validPoint(point) {
        if (!point || typeof point !== 'object') return null;
        const carrier = this.clean(point.type, 20).toLowerCase();
        const id = this.clean(point.code, 100);
        const name = this.clean(point.name, 250);
        const country = this.clean(point.country_code, 2).toUpperCase();
        const original = point.original_point_id == null ? '' : this.clean(point.original_point_id, 100);
        if (!Object.hasOwn(this.carriers, carrier) || !id || !name || country !== 'PL') return null;
        if (point.original_point_id != null && !original) return null;
        return { carrier, id, name, country, original };
      }

      pointFromAttributes(attributes) {
        if (attributes.MA_delivery_preference !== 'locker' || attributes.MA_locker_ready !== 'yes') return null;
        return this.validPoint({
          type: attributes['Pickup carrier'],
          code: attributes['Pickup point ID'],
          name: attributes['Pickup point name'],
          country_code: attributes['Pickup point country'],
          original_point_id: attributes['Pickup original point ID'] || null
        });
      }

      attributes() {
        const attributes = Object.fromEntries(this.keys.map((key) => [key, '']));
        attributes.MA_delivery_preference = this.preference;
        if (this.preference === 'locker' && this.point) {
          attributes.MA_locker_ready = 'yes';
          attributes['Pickup carrier'] = this.point.carrier;
          attributes['Pickup point ID'] = this.point.id;
          attributes['Pickup point name'] = this.point.name;
          attributes['Pickup point country'] = this.point.country;
          attributes['Pickup original point ID'] = this.point.original;
        }
        return attributes;
      }

      matches(attributes, expected) {
        return this.keys.every((key) => String(attributes[key] || '') === expected[key]);
      }

      endpoint(kind) {
        const root = window.Shopify?.routes?.root || '/';
        const path = kind === 'update' ? window.routes?.cart_update_url : window.routes?.cart_url;
        return (path || root + (kind === 'update' ? 'cart/update' : 'cart')).replace(/\.js$/, '') + '.js';
      }

      async request(kind, attributes) {
        const options = { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' };
        if (kind === 'update') {
          options.method = 'POST';
          options.headers['Content-Type'] = 'application/json';
          options.body = JSON.stringify({ attributes });
        }
        const response = await fetch(this.endpoint(kind), options);
        if (!response.ok) throw new Error('cart');
        const cart = await response.json();
        if (!cart || typeof cart.attributes !== 'object' || !Number.isFinite(cart.item_count)) throw new Error('cart');
        return cart;
      }

      commit(attributes, revision) {
        this.pending += 1;
        this.error.textContent = '';
        this.saveFailed = false;
        this.saved = false;
        this.render();
        const operation = this.queue.then(async () => {
          const cart = await this.request('update', attributes);
          if (!this.matches(cart.attributes, attributes)) throw new Error('attributes');
          if (revision === this.revision && this.isConnected) {
            this.itemCount = cart.item_count;
            this.saved = true;
            this.error.textContent = '';
          }
          return cart;
        }).catch(() => {
          if (revision === this.revision && this.isConnected) {
            this.saved = false;
            this.error.textContent = this.dataset.saveError;
            this.saveFailed = true;
          }
          return null;
        }).finally(() => {
          this.pending -= 1;
          if (this.isConnected) this.render();
        });
        this.queue = operation.then(() => undefined);
        return operation;
      }

      async refresh() {
        const epoch = ++this.refreshEpoch;
        const revision = this.revision;
        this.loading = true;
        this.render();
        try {
          await this.queue;
          const cart = await this.request('read');
          if (!this.isConnected || epoch !== this.refreshEpoch || revision !== this.revision) return;
          const attributes = cart.attributes || {};
          this.itemCount = cart.item_count;
          this.preference = attributes.MA_delivery_preference === 'locker' ? 'locker' : 'home';
          this.point = this.pointFromAttributes(attributes);
          this.saved = this.matches(attributes, this.attributes());
          this.error.textContent = '';
          if (!this.saved && this.itemCount) await this.commit(this.attributes(), this.revision);
        } catch {
          if (this.isConnected && epoch === this.refreshEpoch && revision === this.revision) {
            this.saved = false;
            this.error.textContent = this.dataset.saveError;
            this.saveFailed = true;
          }
        } finally {
          if (epoch === this.refreshEpoch) {
            this.loading = false;
            if (this.isConnected) this.render();
          }
        }
      }

      render() {
        const busy = Boolean(this.loading || this.pending || this.mapOpen || this.openingMap || this.proceeding);
        this.setAttribute('aria-busy', busy ? 'true' : 'false');
        this.radios.forEach((radio) => {
          radio.checked = radio.value === this.preference;
          radio.disabled = Boolean(this.loading || this.proceeding || this.mapOpen || this.openingMap);
        });
        this.querySelector('[data-locker-panel]').hidden = this.preference !== 'locker';
        this.chooseButton.disabled = busy || !this.itemCount;
        this.chooseButton.textContent = this.point ? this.dataset.change : this.dataset.choose;
        this.querySelector('[data-point-summary]').hidden = !this.point;
        for (const [field, value] of Object.entries({
          carrier: this.point ? this.carriers[this.point.carrier] : '',
          id: this.point?.id || '',
          name: this.point?.name || ''
        })) this.querySelector('[data-point-' + field + ']').textContent = value;
        this.status.textContent = this.openingMap ? this.dataset.mapLoading : this.pending || this.loading || this.proceeding
          ? this.dataset.saving
          : this.notice || (this.preference === 'locker' ? this.point && this.saved ? this.dataset.ready : this.dataset.chooseHint : '');
        this.error.hidden = !this.error.textContent;
        this.querySelector('[data-save-retry]').hidden = !this.saveFailed;
        this.querySelector('[data-save-retry]').disabled = busy;
        const checkout = document.getElementById('checkout');
        if (checkout) checkout.disabled = busy || !this.itemCount || !this.saved || (this.preference === 'locker' && !this.point);
      }

      loadMap() {
        if (window.Furgonetka?.Map) return Promise.resolve();
        if (!window.maFurgonetkaMapPromise) {
          window.maFurgonetkaMapPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            const finish = (success) => {
              clearTimeout(timeout);
              script.onload = null;
              script.onerror = null;
              if (success && window.Furgonetka?.Map) resolve();
              else {
                script.remove();
                window.maFurgonetkaMapPromise = null;
                reject(new Error('map'));
              }
            };
            const timeout = setTimeout(() => finish(false), 20000);
            script.src = 'https://furgonetka.pl/js/dist/map/map.js';
            script.async = true;
            script.onload = () => finish(true);
            script.onerror = () => finish(false);
            document.head.append(script);
          });
        }
        return window.maFurgonetkaMapPromise;
      }

      dismissMap() {
        if (this.dialog?.open) this.dialog.close();
        if (this.mapContainer) {
          const freshContainer = this.mapContainer.cloneNode(false);
          this.mapContainer.replaceWith(freshContainer);
          this.mapContainer = freshContainer;
        }
      }

      cancelMap() {
        this.mapEpoch += 1;
        this.mapOpen = false;
        this.openingMap = false;
        this.dismissMap();
        this.notice = this.dataset.cancelled;
        this.render();
        this.chooseButton.focus();
      }

      async openMap() {
        if (this.preference !== 'locker' || this.openingMap || this.mapOpen) return;
        const epoch = ++this.mapEpoch;
        this.openingMap = true;
        this.notice = '';
        this.error.textContent = '';
        this.render();
        try {
          await this.loadMap();
          if (!this.isConnected || epoch !== this.mapEpoch || this.preference !== 'locker') return;
          this.openingMap = false;
          this.mapContainer.replaceChildren();
          this.dialog.showModal();
          this.mapOpen = true;
          let selected = false;
          const restoreFocus = () => {
            requestAnimationFrame(() => {
              if (this.isConnected && epoch === this.mapEpoch) this.chooseButton.focus();
            });
          };
          const locale = this.dataset.locale.split('-')[0].toLowerCase();
          new window.Furgonetka.Map({
            apiKey: this.dataset.mapKey,
            container: '#' + this.mapContainer.id,
            courierServices: ['inpost', 'dpd', 'orlen'],
            courierServicesFilter: ['inpost', 'dpd', 'orlen'],
            availableServiceTypes: ['parcel_machine'],
            showServiceTypeFilter: false,
            countryCodesFilter: ['PL'],
            mapBounds: 'pl',
            locale: ['en', 'fr', 'pl'].includes(locale) ? locale : 'en',
            callback: (parameters) => {
              if (selected || !this.isConnected || epoch !== this.mapEpoch || this.preference !== 'locker') return;
              selected = true;
              this.mapOpen = false;
              this.dismissMap();
              const point = this.validPoint(parameters?.point);
              if (!point) {
                this.error.textContent = this.dataset.invalidPoint;
                this.render();
                restoreFocus();
                return;
              }
              this.point = point;
              this.revision += 1;
              this.notice = '';
              this.commit(this.attributes(), this.revision).finally(restoreFocus);
            },
            closeModalCallback: () => {
              if (!this.isConnected || epoch !== this.mapEpoch) return;
              this.mapOpen = false;
              this.dismissMap();
              setTimeout(() => {
                if (selected || !this.isConnected || epoch !== this.mapEpoch) return;
                selected = true;
                this.mapEpoch += 1;
                this.notice = this.dataset.cancelled;
                this.render();
                this.chooseButton.focus();
              }, 0);
              this.render();
              restoreFocus();
            }
          }).show();
          this.render();
        } catch (error) {
          console.warn('Parcel locker map could not open:', error?.name, error?.message);
          if (this.isConnected && epoch === this.mapEpoch) {
            this.mapOpen = false;
            this.dismissMap();
            this.error.textContent = this.dataset.mapError;
          }
        } finally {
          if (epoch === this.mapEpoch) {
            this.openingMap = false;
            if (this.isConnected) this.render();
          }
        }
      }

      async checkout(event) {
        if (event.submitter?.name !== 'checkout') return;
        if (this.allowCheckout) {
          this.allowCheckout = false;
          return;
        }
        event.preventDefault();
        if (this.proceeding || this.loading || this.mapOpen || this.openingMap) return;
        if (this.preference === 'locker' && !this.point) {
          this.error.textContent = this.dataset.invalidPoint;
          this.render();
          this.chooseButton.focus();
          return;
        }
        const revision = this.revision;
        const submitter = event.submitter;
        this.proceeding = true;
        this.render();
        const cart = await this.commit(this.attributes(), revision);
        this.proceeding = false;
        this.render();
        if (!cart || !this.isConnected || revision !== this.revision || !cart.item_count || !this.saved) return;
        this.allowCheckout = true;
        this.form.requestSubmit(submitter);
        this.allowCheckout = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
